import { Skeleton } from "@/components/ui/skeleton";

export default function ProductCardSkeleton() {
  return (
    <div className="border border-slate-200 bg-white flex flex-col" data-testid="product-skeleton">
      <Skeleton className="w-full aspect-[4/3] rounded-none bg-slate-200" />
      <div className="p-5 flex flex-col gap-3">
        <Skeleton className="h-2.5 w-16 rounded-none bg-slate-200" />
        <Skeleton className="h-4 w-full rounded-none bg-slate-200" />
        <Skeleton className="h-4 w-2/3 rounded-none bg-slate-200" />
        <Skeleton className="h-3 w-24 rounded-none bg-slate-200 mt-1" />
        <div className="flex items-end justify-between pt-3 mt-1 border-t border-slate-100">
          <div className="space-y-2">
            <Skeleton className="h-2 w-10 rounded-none bg-slate-200" />
            <Skeleton className="h-6 w-24 rounded-none bg-slate-200" />
          </div>
          <Skeleton className="h-10 w-10 rounded-none bg-slate-200" />
        </div>
      </div>
    </div>
  );
}
